import { render, staticRenderFns } from "./BookPageMain.vue?vue&type=template&id=eea4f160&scoped=true&"
import script from "./BookPageMain.vue?vue&type=script&lang=js&"
export * from "./BookPageMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea4f160",
  null
  
)

export default component.exports